import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function payConfigList(data) { return axios.post(`${base.url}/payment/payConfig/list`, qs.stringify(data)) }
export function payConfigDetail(id) { return axios.post(`${base.url}/payment/payConfig/detail`, qs.stringify({ id })) }
export function payConfigAddOrUpdate(data) { return axios.post(`${base.url}/payment/payConfig/addOrUpdate`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }
export function payConfigDelete(id) { return axios.post(`${base.url}/payment/payConfig/deleteBatchIds`, qs.stringify({ ids: id })) }
export function payConfigStatus(id, status) { return axios.post(`${base.url}/payment/payConfig/status`, qs.stringify({ id, status })) }
export function payConfigGenerateKeyPair() { return axios.post(`${base.url}/payment/payConfig/generateKeyPair`, qs.stringify({})) }
